import { faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faBox, faCalendar, faCalendarAlt, faUpload  } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuFooter from '../Component/MenuFooter';
import { ImageOff } from "lucide-react";
import Header1 from '../Component/Header1';
import UMR from '../UMR';




const MaterialsListScreen = ({ onBack, newRFQ }) => {
  const navigate = useNavigate();
  const [materials, setMaterials] = useState([]);
  const [expandedMaterial, setExpandedMaterial] = useState(null);
 const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
   const [loadingmaterials, setLoadingmaterials] = useState(false);
   const [previewImage, setPreviewImage] = useState(null);
const [showPreview, setShowPreview] = useState(false);
const [currentImageIndex, setCurrentImageIndex] = useState(0);
const [showUMR, setShowUMR] = useState(false);
const [categories, setCategories] = useState([]); 
const [expandedMaterials, setExpandedMaterials] = useState([]);



 


  // useEffect(() => {
  //   loadMaterials();

  //   if (newRFQ) {
  //     setTimeout(() => {
  //       const updatedMaterials = materials.map(material => 
  //         material.id === newRFQ.id ? { ...material, isNew: false } : material
  //       );
  //       localStorage.setItem('materialRFQs', JSON.stringify(updatedMaterials));
  //       setMaterials(updatedMaterials);
  //     }, 5000);
  //   }
  // }, [newRFQ]);

  useEffect(() => {
    fetchallcustomermaterialrequirements();
  }
, []);




 useEffect(() => {
  if (materials.length > 0) {
    setExpandedMaterials(materials.map((m) => m._id));
  }
}, [materials]);

const toggleExpand = (materialId) => {
  setExpandedMaterials((prev) =>
    prev.includes(materialId)
      ? prev.filter((id) => id !== materialId) // close if already open
      : [...prev, materialId] // open if closed
  );
};

  

  const getStatusConfig = (status) => {
    switch (status) {
      case "under_review":
        return {
          label: "Under Review",
          color: "text-blue-700",
          bgColor: "bg-blue-50",
        };
      case "verified":
        return {
          label: "Verified",
          color: "text-green-700",
          bgColor: "bg-green-50",
        };
      case "processed":
        return {
          label: "processing",
          color: "text-blue-700",
          bgColor: "bg-blue-50",
        };
      default:
        return {
          label: "Under Review",
          color: "text-amber-700",
          bgColor: "bg-amber-50",
        };
    }
  };


  const fetchallcustomermaterialrequirements = async () => {
    try {
          setLoadingmaterials(true);
      const userData = JSON.parse(sessionStorage.getItem("userData"));
    const customerId = userData?._id;
          const token = sessionStorage.getItem('token');

     const response = await fetch(
      `${fetchUrl}customer/material-requirement/get-all-customer-material-requirements?customer_id=${customerId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        }
      });
      if (response.ok) {
        const data = await response.json();
      setMaterials(data.data); 
        console.log('All Customers Material Requirements:', data);
        // Process the data as needed
      } else {
        console.error('Error fetching material requirements:', response.statusText);
      } 

    } catch (error) {
      console.error('Fetch error:', error);
    }
    finally {
      setLoadingmaterials(false);
    }
  }

  
/* const handleCardButtonClick = (ids, buttonType) => {
  navigate("/consumer/app/reviewitemlist", {
    state: {
      materialRequirementId: ids.materialRequirementId,
      materialItemId: ids.materialItemId,
      buttonType: buttonType,
      MR_images: ids.MR_images,
      mrId: ids.mrId,
    },
  });
}; */

const handleCardButtonClick = (data, actionType) => {
  if (actionType === "viewRFQ") {
    console.log("RFQ Clicked:", data.rfqId);
    // Navigate to RFQ page with only RFQ ID
    navigate("/consumer/app/reviewitemlist", {
      state: {
        rfqId: data.rfqId,
        buttonType: actionType
      }
    });
  } else if (actionType === "viewDetails") {
    console.log("Review Items Clicked");
    // Navigate to review page with all material data
    navigate("/consumer/app/reviewitemlist", {
      state: {
        materialRequirementId: data.materialRequirementId,
        materialItemId: data.materialItemId,
        buttonType: actionType,
        MR_images: data.MR_images,
        mrId: data.mrId,
      }
    });
  }
};




  const handleRFQClick = (rfq_id, actionType) => {
  if(actionType === "viewRFQ") {
    navigate("/consumer/app/rfqdetails", { state: { rfq_id } });
  }
};

  if (loadingmaterials) {
    return (
      <div className="fixed inset-0 flex flex-col items-center justify-center bg-opacity-70 backdrop-blur-sm z-50">
        <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-gray-400 text-xs">Loading material List...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <Header1
  title="Material Requirements"
  showSearch={false}
    showList={true} 
  onListClick={() => setShowUMR(true)}
  backPath="/consumer/projectdetails"

/>

 


      {/* Materials List */}
 <div className="flex-1 overflow-y-auto pb-24 px-4 py-5 space-y-4">
  {materials.map((material) => {
    const statusConfig = getStatusConfig(material.status);
  const isExpanded = expandedMaterials.includes(material._id); 

    // Calculate total items count from nested material_items[].items arrays
    const totalItemCount =
      material.material_items?.reduce((acc, mi) => {
        return acc + (mi.items?.length || 0);
      }, 0) || 0;

    return (
      <div
        key={material._id}
        className="border border-gray-200 rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-200 bg-white"
      >
        {/* Material Header */}
        <div
          className="flex items-start gap-4 p-4 cursor-pointer"
          onClick={() => toggleExpand(material._id)}
        >
          {/* Image */}
<div
  className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden bg-gray-100 ${
    material.material_list_attachments?.length ? 'cursor-pointer hover:opacity-80' : ''
  } flex items-center justify-center`}
  onClick={() => {
    if (material.material_list_attachments?.length > 0) {
      setPreviewImage(material.material_list_attachments);
      setCurrentImageIndex(0);
      setShowPreview(true);
    }
  }}
>
  {material.material_list_attachments?.[0]?.uri ? (
    <img
      src={`${process.env.REACT_APP_FORE_BRICKBUCKET}${material.material_list_attachments[0].uri}`}
      alt="Material requirement"
      className="w-full h-full object-cover"
    />
  ) : (
    <ImageOff className="w-10 h-10 text-gray-400" />
  )}
</div>

{showPreview && previewImage && (
  <div
    className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
    onClick={() => setShowPreview(false)}
  >
    <div
      className="relative w-full h-full flex items-center justify-center overflow-hidden"
      onClick={(e) => e.stopPropagation()}
    >
      {/* ✖ Close Button */}
      <button
        onClick={() => setShowPreview(false)}
        className="absolute top-4 right-4 text-white text-3xl bg-black/50 rounded-full w-9 h-9 flex items-center justify-center z-20"
      >
        &times;
      </button>

      {/* ‹ Left Arrow */}
      {previewImage.length > 1 && (
        <button
          onClick={() =>
            setCurrentImageIndex(
              (prev) => (prev - 1 + previewImage.length) % previewImage.length
            )
          }
          className="absolute left-4 text-white text-4xl bg-black/40 rounded-full w-10 h-10 flex items-center justify-center z-20"
        >
          ‹
        </button>
      )}

      {/* ✅ Native Pinch + Scroll Area */}
      <div
        className="w-full h-full overflow-auto flex items-center justify-center bg-black no-scrollbar"
        style={{
          WebkitOverflowScrolling: "touch", // smooth scroll
          overscrollBehavior: "contain", // prevent bounce
          touchAction: "pan-x pan-y pinch-zoom", // enables native pinch zoom
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style>
          {`
            .no-scrollbar::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>

        {/* 🖼️ Normal display at first — object-contain */}
        <img
          src={`${process.env.REACT_APP_FORE_BRICKBUCKET}${previewImage[currentImageIndex].uri}`}
          alt="Preview"
          className="select-none object-contain"
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "90vh",
            userSelect: "none",
            touchAction: "pan-x pan-y pinch-zoom",
            display: "block",
          }}
          draggable={false}
        />
      </div>

      {/* › Right Arrow */}
      {previewImage.length > 1 && (
        <button
          onClick={() =>
            setCurrentImageIndex((prev) => (prev + 1) % previewImage.length)
          }
          className="absolute right-4 text-white text-4xl bg-black/40 rounded-full w-10 h-10 flex items-center justify-center z-20"
        >
          ›
        </button>
      )}

      {/* 🔢 Counter */}
      {previewImage.length > 1 && (
        <div className="absolute bottom-4 text-white text-sm bg-black/50 px-3 py-1 rounded-full z-20">
          {currentImageIndex + 1}/{previewImage.length}
        </div>
      )}
    </div>
  </div>
)} 







 

          {/* Details */}
          <div className="flex flex-col flex-1 justify-between min-w-0">
            {/* Date + Collapse */}
            <div className="flex items-start justify-between">
              <div className="flex items-center">
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  className="mr-2 text-gray-400 text-xs"
                />
                <p className="text-base font-semibold text-gray-900 truncate">
                  {material.created_at
                    ? new Date(material.created_at).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })
                    : "Oct 10, 2025"}
                </p>
              </div>

              {/* Right side: Expand / Collapse icon */}
             <FontAwesomeIcon
             icon={isExpanded ? faAngleUp : faAngleDown}
               className={`text-md transition-transform duration-300 ${
              isExpanded ? "text-gray-500" : "text-gray-500"
             }`}
             />

            </div>

            {/* MR Number */}
            <div className="flex items-center text-sm text-gray-500 mt-1">
              <span className="font-medium text-gray-500">
                {material.mr_number}
              </span>
            </div>

            {/* Status + Item Count */}
            <div className="flex items-center gap-3 mt-3">
              <span
                className={`inline-flex px-3 py-1 text-xs font-medium rounded-full ${statusConfig.bgColor} ${statusConfig.color}`}
              >
                {statusConfig.label}
              </span>
             {totalItemCount > 0 && (
    <div className="flex items-center text-xs text-gray-600">
      <FontAwesomeIcon icon={faBox} className="mr-1 text-gray-400" />
      <span className="font-medium text-gray-700">
        {totalItemCount} Items
      </span>
    </div>
  )}
            </div>
          </div>
        </div>

        {/* Expandable Content with Cards or Review Items Button */}
{isExpanded && (
  <div className="border-t border-gray-200 pt-0">
    <div className="space-y-2">
      {material.material_items?.length > 0 ? (
        material.material_items.map((catItem, catIndex) => (
          <div
  key={catItem._id || catIndex}
  className="flex items-center justify-between p-4 bg-white hover:bg-gray-50 rounded-xl  transition-all duration-200 shadow-sm hover:shadow-md group"
>
  {/* Category Info */}
  <div className="flex items-start gap-3 flex-1 min-w-0">
    {/* Category Text */}
    <div className="flex-1 min-w-0">
      <h3 className="text-sm font-semibold text-gray-800 leading-tight truncate">
        {catItem.product_category_ids?.length > 0
          ? catItem.product_category_ids.map(cat => cat.product_category_name).join(', ')
          : "Uncategorized"}
      </h3>
      <div className="flex items-center gap-1 mt-0.5">
        <span className="text-xs font-medium text-gray-500 whitespace-nowrap">
          • {catItem?.items?.length || 0} Items
        </span>
      </div>
    </div>
  </div>

  {/* Action Button */}
  <div className="flex-shrink-0 ml-4">
    {catItem.rfq_number ? (
      <button
        onClick={e => {
    e.stopPropagation();
    handleRFQClick(catItem.rfq_id, "viewRFQ");
  }}

        className="flex flex-row justify-between items-center px-4 py-1.5 text-sm font-medium rounded-lg bg-gradient-to-r from-red-600 to-red-700 text-white hover:from-red-700 hover:to-red-800 shadow-sm hover:shadow transition-all"
      >
       <p>{catItem.rfq_number}</p> 
       <FontAwesomeIcon icon={faAngleRight} className="ml-1 "/>
      </button>
    ) : (
      <button
        onClick={(e) => {
          e.stopPropagation();
          handleCardButtonClick(
            {
              materialRequirementId: catItem.material_requirement_id,
              materialItemId: catItem._id,
              mrId: material.mr_number,
              MR_images: material.material_list_attachments,
            },
            "viewDetails"
          );
        }}
        className="flex flex-row justify-between items-center px-4 py-1.5 text-sm font-medium text-blue-600 border border-blue-100 hover:border-blue-300 hover:bg-blue-50 rounded-lg transition-all duration-200"
      >
        <p>Review</p> 
        <FontAwesomeIcon icon={faAngleRight} className="ml-1 "/>
      </button>
    )}
  </div>
</div>

        ))
      ) : (
    <div className="py-4">
  <p className="text-gray-500 text-sm text-left ml-5">{material.description}</p>
</div>


      )}
    </div>
  </div>
)}


      </div>
    );
  })}

  {/* Empty State */}
  {materials.length === 0 && (
    <div className="text-center py-24">
      <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mx-auto mb-5">
        <span className="text-4xl text-gray-400">📦</span>
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        No Material Requirements
      </h3>
      <p className="text-gray-500 mb-8 max-w-md mx-auto text-sm">
        Upload images of materials you need quotes for to get started.
      </p>
      <button
       onClick={() => setShowUMR(true)} 
        className="px-6 py-2.5 bg-gray-900 text-white rounded-xl font-medium hover:bg-gray-800 transition-colors"
      >
        Upload First Requirement
      </button>
    </div>
  )}

</div>

<UMR
  visible={showUMR}
  onClose={() => {
    setShowUMR(false);
    fetchallcustomermaterialrequirements(); 
  }}
/>

  <MenuFooter />
    </div>

  );
};

export default MaterialsListScreen;

